import React, { MutableRefObject, useRef } from 'react';
import { cx } from 'linaria';
import { Layout, Typography } from 'fronton-react';
import { BreadcrumbsSection } from 'features/breadcrumbs';
import { useBreakpoints } from 'common/hooks/use-breakpoints';
import { useEffectOnce } from 'common';
import { useOptimizedImages } from 'common/hooks/use-optimized-images';
import { carouselScroll } from 'utils/carousel-scroll';
import {
  aboutParagraph,
  heading,
  heroContainer,
  heroTopPadding,
  scrollCarousel,
  subHeading,
  textCenter,
} from '../styles';

export const HeroSection: React.FC = () => {
  const { mobile, tablet } = useBreakpoints() || {};
  const slider = useRef<HTMLDivElement | null>(null);
  let pos = { left: 0, x: 0 };

  useEffectOnce(() => {
    carouselScroll(pos, slider as MutableRefObject<HTMLDivElement>);
  });
  const imgUrl =
    'https://cdn.lemanapro.ru/lmru/image/upload/v1718704112/fudzi/navigation-microfronts/about_banner.png/about_banner.png';
  const optimizedImage = useOptimizedImages(imgUrl, {
    rest: {
      h: '405',
    },
  });

  return (
    <section className={cx(heroContainer, textCenter)}>
      <Layout>
        <BreadcrumbsSection />
        <Typography
          variant="l"
          size="body_long"
          as={mobile ? 'h2' : 'h1'}
          color="text-primary"
          className={heroTopPadding}
        >
          О компании Лемана ПРО
        </Typography>
        <Typography variant={mobile ? 'h2' : 'h1'} color="text-primary" className={heading}>
          Заботимся о доме, думая о будущем
        </Typography>
        <Typography variant="l" size="body_short" color="text-primary" className={aboutParagraph}>
          Мы&nbsp;помогаем&nbsp;нашим покупателям&nbsp;и профессиональным клиентам создавать и&nbsp;улучшать
          дом, делая его комфортным,&nbsp;здоровым, долговечным. Мы&nbsp;даем каждому возможность экономить
          ресурсы, выбирать безопасные товары и&nbsp;вносить положительный вклад в&nbsp;построение нашего
          общего будущего.
        </Typography>
        <div className={scrollCarousel} ref={slider}>
          <picture>
            <source srcSet={`${optimizedImage.rest?.xx} 2x, ${optimizedImage.rest?.x} 1x`} />
            <img
              alt="О компании"
              src={optimizedImage.rest?.x ?? undefined}
              srcSet={`${optimizedImage.rest?.xx} 2x, ${optimizedImage.rest?.x} 1x`}
              draggable={false}
            />
          </picture>
        </div>
        {mobile ? (
          <Typography variant="l" size="body_accent" className={subHeading}>
            <span>Наша цель — это довольный клиент, </span>
            который смог реализовать свой проект от идеи до воплощения в&nbsp;рамках запланированного
            бюджета.
          </Typography>
        ) : (
          <Typography variant="h2" as="h2" className={subHeading}>
            <span>Наша цель — это довольный клиент, </span>
            который {tablet ? <br /> : <></>}смог {tablet ? <></> : <br />}реализовать свой проект от идеи до{' '}
            {tablet ? <br /> : <></>}
            воплощения в&nbsp;рамках запланированного
            {tablet ? <br /> : <></>} бюджета.
          </Typography>
        )}
      </Layout>
    </section>
  );
};
